import React from "react";
import {
  Box,
  Button,
  Card,
  CardBody,
  Heading,
  SimpleGrid,
  Text,
  VStack,
} from "@chakra-ui/react";
import { Link as RouterLink, Navigate } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { getDefaultAuthenticatedRoute, getNetworkMemberships } from "../../utils/authRoles";
import { getDisplayRoleLabel } from "../../utils/displayRole";

const NetworkSelectionPage = () => {
  const { user, isLoading } = useUser();

  if (isLoading) return null;

  const memberships = getNetworkMemberships(user);
  if (memberships.length === 0) return <Navigate to={getDefaultAuthenticatedRoute(user)} replace />;
  if (memberships.length === 1) return <Navigate to={`/app/network/${memberships[0].network_id}`} replace />;

  return (
    <VStack align="stretch" spacing={6}>
      <Box>
        <Heading size="lg">Select Network</Heading>
        <Text color="gray.600" mt={2}>
          Choose the network dashboard you want to open.
        </Text>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 2, xl: 3 }} spacing={4}>
        {memberships.map((membership) => (
          <Card key={membership.network_id}>
            <CardBody>
              <VStack align="start" spacing={3}>
                <Box>
                  <Heading size="md">{membership.network_name}</Heading>
                  <Text color="gray.600" fontSize="sm">
                    {getDisplayRoleLabel(membership.role_name)}
                  </Text>
                </Box>
                <Button
                  as={RouterLink}
                  to={`/app/network/${membership.network_id}`}
                  colorScheme="blue"
                  variant="outline"
                >
                  Open network
                </Button>
              </VStack>
            </CardBody>
          </Card>
        ))}
      </SimpleGrid>
    </VStack>
  );
};

export default NetworkSelectionPage;
